import { useState as l, useEffect as p, createElement as a } from "react";
function m(i, d = 0) {
  let s = null, u = 0;
  const c = (e) => (n) => {
    if (!s) return;
    const r = s;
    r(
      (o) => o.map((t) => e && t.promise !== e ? t : (t.resolve(n), { ...t, ended: !0 }))
    ), globalThis.setTimeout(
      () => r(
        (o) => o.filter((t) => e && t.promise !== e)
      ),
      d
    );
  };
  return {
    call: (e) => {
      if (!s) throw new Error("No <Root> found!");
      const n = String(u++);
      let r;
      const o = new Promise((t) => {
        r = t;
      });
      return s((t) => [
        ...t,
        { key: n, props: e, promise: o, resolve: r, end: c(o), ended: !1 }
      ]), o;
    },
    end: (...e) => {
      const n = e.length === 2;
      return c(n ? e[0] : null)(n ? e[1] : e[0]);
    },
    update: (...e) => {
      if (!s) return;
      const n = s, r = e.length === 2;
      n(
        (o) => o.map(
          (t) => r && t.promise !== e[0] ? t : {
            ...t,
            props: { ...t.props, ...r ? e[1] : e[0] }
          }
        )
      );
    },
    Root: (e) => {
      const [n, r] = l([]);
      return p(() => {
        if (s) throw new Error("Multiple instances of <Root> found!");
        return s = r, () => {
          s = null, u = 0;
        };
      }, []), n.map(({ props: o, ...t }, f) => /* @__PURE__ */ a(
        i,
        {
          ...o,
          key: t.key,
          call: {
            ...t,
            root: e,
            index: f,
            stackSize: n.length
          }
        }
      ));
    }
  };
}
export {
  m as createCallable
};
